import type { SiteListItem } from "./useSiteList";

export function renderSiteType(siteType: SiteListItem["siteType"]): string {
  let label: string;
  if (siteType === "domain") {
    label = "Домен";
  } else {
    label = "Субдомен";
  }
  return label;
}
